import { GetRequest } from "../../service"

const ControllerName = "BrokerRequest"

export const GetBrokerMedicalRequests = (data) =>
    GetRequest(`${ControllerName}`, data)

export const GetBrokerMedicalRequestDetails = (id) =>
    GetRequest(`${ControllerName}/getQuotationDetails/${id}`)

export const GetBrokerRequestPreviousOffer = (id) =>
    GetRequest(`${ControllerName}/getPreviousOffer/${id}`)


export const GetProviderQuotationResponseDetails = (id) =>
    GetRequest(`${ControllerName}/GetProviderQuotationResponseDetails/${id}`)
